import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import profileCustomAction from '~/modules/master/redux/actions/profile-custom'

const useProfileCustom = () => {
  const data = useSelector((state) => get(state, 'master.profileCustom'))

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(profileCustomAction, dispatch),
    [dispatch],
  )
  return {
    actions,
    data,
  }
}

export default useProfileCustom
